import getBG from '../../utils/utils';

export default {
    name: 'FAQs-detail',
    data() {
        return {
            content: '',
            backgroundImage: ''
        };
    },
    created() {
        this.init();
    },
    mounted() {},
    methods: {
        async init() {
            this.getContext();
            this.backgroundImage = await getBG.call(this, 'WanXunInfo');
        },
        // 查询富文本信息
        getContext() {
            this.$http
                .fetchData('contentManage/getContentManageList', {
                    id: this.$route.query.id
                })
                .then(res => {
                    console.log(res);
                    this.content = res[0].content;
                })
                .catch(err => {
                    this.$message({
                        message: err,
                        type: 'error'
                    });
                });
        }
    }
};
